import { salaryFromInput, salaryToInput } from "@/lib/countries";

const UNITS = [
  { key: "lpa", label: "LPA (Lakhs per annum)" },
  { key: "annual", label: "Annual (₹ full amount)" },
];

// Switching unit converts the typed Min/Max so the value keeps its meaning.
export const switchSalaryUnit = (form, unit) => ({
  ...form,
  salary_unit: unit,
  salary_min: salaryToInput(salaryFromInput(form.salary_min, form.salary_unit), unit),
  salary_max: salaryToInput(salaryFromInput(form.salary_max, form.salary_unit), unit),
});

export default function SalaryUnitToggle({ form, setForm, testid }) {
  if (form.salary_currency !== "INR") return null;
  return (
    <div className="flex flex-wrap items-center gap-2 -mt-1" data-testid={testid}>
      <span className="text-xs text-slate-400 uppercase tracking-wider mr-1">Salary unit</span>
      {UNITS.map(u => {
        const on = form.salary_unit === u.key;
        return (
          <button type="button" key={u.key} data-testid={`${testid}-${u.key}`} aria-pressed={on}
            onClick={() => setForm(switchSalaryUnit(form, u.key))}
            className={`px-3 py-1.5 text-xs rounded-lg border transition-colors ${on ? "bg-indigo-600 border-indigo-600 text-white" : "border-[color:var(--bd-sub)] text-slate-600 hover:border-indigo-400"}`}>
            {u.label}
          </button>
        );
      })}
      {form.salary_unit === "lpa" && <span className="text-[11px] text-slate-500">e.g. Min 20, Max 30 = ₹20 – 30 LPA</span>}
    </div>
  );
}
